import { useTranslation } from 'react-i18next';

import { OnetimePeriod } from './../types/PlanPaymentTypes';

export const useConvertOnetimePeriodToText = () => {
  const { t } = useTranslation(['subscription']);

  const convertOnetimePeriodToText = (period: OnetimePeriod | '') => {
    const periodMap: { [key: string]: string } = {
      '': '',
      ...Object.fromEntries(
        [1, 3].map(day => [
          `${day}D`,
          t('subscription:payment.calendar.days', {
            day: day,
            defaultValue: `${day}일`,
          }),
        ]),
      ),
      ...Object.fromEntries(
        Array.from({ length: 12 }, (_, i) => [
          `${i + 1}M`,
          t('subscription:payment.calendar.months', {
            month: i + 1,
            defaultValue: `${i + 1}개월`,
          }),
        ]),
      ),
    };

    return periodMap[period] || period;
  };

  return { convertOnetimePeriodToText };
};
